export enum AnalyticsEvent {
    PHOTO_UPLOAD_ERROR = 'PHOTO_UPLOAD_ERROR',
    PHOTOS_UPLOADED = 'PHOTOS_UPLOADED',
    POI_SUGGESTED_EVENT = 'POI_SUGGESTED_EVENT',
    SEARCH_DIALOG_OPENED = 'SEARCH_DIALOG_OPENED'
}

export type AnalyticsParams = Record<string, unknown>;
